import InformationGrayIcon from "static/images/information-icon-gray.svg";

interface Props {
  className?: string;
}

export default function InformationGrayedIcon(props: Props) {
  return (
    <img
      src={InformationGrayIcon}
      alt={"information"}
      className={props.className ?? ""}
    />
  );
}
